var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar-minimize-fixed",staticStyle:{"opacity":"1"}},[_c('fade-transition',[(_vm.showButton)?_c('sidebar-toggle-button',{staticClass:"text-muted"}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }